import apiClient from '../client';
import type { IntercropLink, CreateIntercropLinkRequest } from '../../types';

const intercropLinkService = {
  getAll: async () => {
    const response = await apiClient.get<IntercropLink[]>('/intercrop-links');
    return response.data;
  },

  getByProject: async (projectId: string) => {
    const response = await apiClient.get<IntercropLink[]>(`/intercrop-links/project/${projectId}`);
    return response.data;
  },

  getByOperation: async (operationId: string) => {
    const response = await apiClient.get<IntercropLink[]>(`/intercrop-links/operation/${operationId}`);
    return response.data;
  },

  create: async (data: CreateIntercropLinkRequest) => {
    const response = await apiClient.post<IntercropLink>('/intercrop-links', data);
    return response.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/intercrop-links/${id}`);
  },
};

export default intercropLinkService;
